// ==========================================================================
// Loan Offering Service - Acknowledge loan offering
// POST /api/user/loan-offering/acknowledge
// ==========================================================================

import api from '@/lib/axios';
import type { AcknowledgeLoanOfferingResponse } from '@/types/alert.types';

/**
 * Acknowledge the loan offering (marks as seen, triggers WhatsApp notification).
 * Called when the loan offering modal is first displayed to the user.
 */
export async function acknowledgeLoanOffering(): Promise<AcknowledgeLoanOfferingResponse> {
  const response = await api.post<AcknowledgeLoanOfferingResponse>('/user/loan-offering/acknowledge');
  return response.data;
}
